import React, { useState, useEffect } from "react";
import SearchMessaje from '../../../assets/undraw_file_searching_re_3evy.svg'
import NotFound from  '../../../assets/undraw_no_data_re_kwbl.svg'

import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  LinearProgress,
  Tooltip,
  Box,
  Typography,
  Grid,
} from "@mui/material";
import { useSelector } from "react-redux";
import colors from "../../../config/colors";

import {
  tableCellHeaderTable,
  tableCellHeaderAccionTable,
  tableCellRowTable,
  paperContainerTable,
  containerTable,
  tablePaginationTable,
} from "../../global/styles";

const handlerSelected = () => {};

const CustomTable = ({
  columns,
  rows,
  acciones,
  loading,
  handlerSelectedItem = handlerSelected,
  handlerPage,
  totalDisponibles,
  initialRowsPerPage = 10,
  rowsPerPageOptions = [5, 10, 25, 100],
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
  const isUltra = useSelector((state) => state.afiliado.infoAfiliado.isUltra);
  const ultraDarkMode = useSelector((state) => state.afiliado.infoAfiliado.ultraDarkMode);
  const isDark = isUltra && ultraDarkMode;

  const ultraHeaderCell = isDark ? {
    backgroundColor: colors.ultraSurface,
    color: colors.ultraAccentLight,
    borderColor: 'rgba(255,255,255,0.08)',
  } : {};
  const ultraBodyCell = isDark ? {
    backgroundColor: colors.ultraMid,
    color: colors.ultraSilver,
    borderColor: 'rgba(255,255,255,0.06)',
  } : {};
  const ultraPaper = isDark ? {
    backgroundColor: colors.ultraMid,
    borderColor: colors.ultraBorder,
  } : {};
  const ultraPagination = isDark ? {
    backgroundColor: colors.ultraSurface,
    color: colors.ultraSilver,
    borderColor: 'rgba(255,255,255,0.08)',
  } : {};

  // Clamp / reset the current page whenever the total record count changes
  // (e.g. a new search returned fewer results than the current page index).
  useEffect(() => {
    const total = Number(totalDisponibles) || 0;
    const lastPage = total > 0 ? Math.ceil(total / rowsPerPage) - 1 : 0;
    if (page > lastPage) {
      setPage(0);
    }
  }, [totalDisponibles, rowsPerPage, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // Backend expects 1-based page index.
    handlerPage(newPage + 1, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    // Reset to first page on page-size change.
    handlerPage(1, newRowsPerPage);
  };

  return loading ? (
    <LinearProgress />
  ) : rows ? (
    rows.length === 0 ? (
      <Grid container justifyContent={"center"} alignItems={"center"}>
        <Grid textAlign={"center"} marginTop={10}>
          <img width={250} height={250} src={NotFound} alt="Sin resultados" />
          <Grid marginTop={10}>
            <p style={{ textAlign: "center", fontSize: 20 }}>
              <b>No se encontraron resultados.</b>
              <br />
              Intente con una busqueda diferente o <br />
              verifique los criterios utilizados
            </p>
          </Grid>
        </Grid>
      </Grid>
    ) : (
      <Paper
        style={{
          ...paperContainerTable,
          ...ultraPaper,
        }}
        sx={{ width: { xs: 400, md: "96%" } }}
      >
        <TableContainer
          style={{
            ...containerTable,
          }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    style={{
                      ...tableCellHeaderTable,
                      minWidth: column.minWidth,
                      ...ultraHeaderCell,
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
                {acciones ? (
                  <TableCell
                    style={{
                      ...tableCellHeaderAccionTable,
                      width: acciones.length > 1 ? 240 : "auto",
                      ...ultraHeaderCell,
                    }}
                  >
                    <Grid textAlign={"center"}>Acciones</Grid>
                  </TableCell>
                ) : null}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                ? rows.map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        onClick={() => handlerSelectedItem(row)}                        sx={isDark ? {
                          '&:hover td': { backgroundColor: colors.ultraSurface },
                        } : {}}                      >
                        {columns.map((column, columnIndex) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={columnIndex}
                              style={{
                                ...tableCellRowTable,                                ...ultraBodyCell,                              }}
                            >
                              {column.format ? column.format(value) : value}
                            </TableCell>
                          );
                        })}

                        {acciones ? (
                          <TableCell
                            sx={{
                              ...tableCellRowTable,
                              ...ultraBodyCell,
                              height: 60,
                              padding: { xs: "8px", sm: "12px" },
                              flexWrap: "wrap",
                            }}
                          >
                            <Grid container spacing={1}>
                              {acciones.map((accion, indexx) => (
                                <Grid
                                  key={`${indexx}-${index}`}
                                  item
                                  xs={12}
                                  md={acciones.length > 1 ? 6 : 12}
                                >
                                  <Box
                                    onClick={() => accion.metodo(row)}
                                    sx={{
                                      cursor: "pointer",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      padding: "0px",
                                      "&:hover": {
                                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                                        borderRadius: "8px",
                                      },
                                    }}
                                  >
                                    <Tooltip title={accion.label} arrow>
                                      {accion.icono}
                                    </Tooltip>
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        marginTop: "0px",
                                        color: isUltra ? colors.ultraAccentLight : "gray",
                                        textAlign: "center",
                                      }}
                                    >
                                      {accion.label}
                                    </Typography>
                                  </Box>
                                </Grid>
                              ))}
                            </Grid>
                          </TableCell>
                        ) : null}
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
        {rows ? (
          <TablePagination
            style={{
              ...tablePaginationTable,
              ...ultraPagination,
            }}
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            count={Number(totalDisponibles) || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={
              <label style={{ fontWeight: "bold" }}>Registros por pagina</label>
            }
          />
        ) : null}
      </Paper>
    )
  ) : (
    <Grid container justifyContent={"center"} marginTop={10}>
      <Grid>
        <img src={SearchMessaje} width={250} height={250} alt="Buscar informacion" />
        <Grid marginTop={10}>
          <p style={{ textAlign: "center", fontSize: 20 }}>
            Realice una consulta para obtener y <br />
            mostrar los resultados.
          </p>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CustomTable;
